module.exports = "pegasus/assets/column-8-basic.png";